import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import YesIcon from '../../Icons/YesIcon'
import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import { ActiveSelectField, useActiveSelectField } from '../../context/ActiveSelectFieldProvider'

const currencyOptions: {
  code: 'EUR' | 'MAD'
  labelKey: string
}[] = [
  { code: 'EUR', labelKey: 'EURO' },
  { code: 'MAD', labelKey: 'DIRHAM' },
]

const Currency: React.FC = () => {
  const { t } = useTranslation()
  const {
    state: { selectedCurrency },
    dispatch,
  } = useTravelSearchContext()
  const { closeIfActive } = useActiveSelectField()

  const handleSelect = (currency: 'EUR' | 'MAD') => {
    dispatch({ type: 'SET_CURRENCY', currency })
    closeIfActive(ActiveSelectField.CURRENCY)
  }

  return (
    <div className="ts-bg-dfds-surface-light">
      <ul className="ts-p-0 ts-m-0 ts-w-full ts-list-none ts-border-0 ts-border-solid">
        {currencyOptions.map(({ code, labelKey }) => (
          <li
            key={code}
            data-e2e={`currency-${code.toLowerCase()}`}
            className={clsx(
              'ts-list-none ts-flex ts-items-center ts-h-[90px] ts-px-dfds-s ts-border-0 ts-border-b ts-border-solid ts-border-b-dfds-divider-dark ts-cursor-pointer',
              selectedCurrency === code ? 'ts-bg-cvi-states-selected' : 'ts-bg-dfds-surface-light lg:hover:ts-bg-cvi-states-hover'
            )}
            onClick={() => handleSelect(code)}
          >
            <label className="ts-text-cvi-brand-brand900 ts-font-medium ts-cursor-pointer">{t(labelKey)}</label>
            {selectedCurrency === code && (
              <div className="ts-ml-auto ts-text-cvi-brand-brand900">
                <YesIcon size="md" />
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default Currency
